import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Switch, Route } from 'react-router-dom';
import { Loader } from '@sunbit-dev/purchase-common/src/components/loader/Loader';
import { Routes as PreScreenRoutes } from '~/preScreen/enums/Routes';
import { Routes as RetailerCustomerViewRoutes } from '@sunbit-dev/retailer-customer-view/src/enums/Routes';

const CheckoutApplication = lazy(() =>
  import('./CheckoutApplication').then((module) => ({ default: module.CheckoutApplication }))
);

const RetailerCustomerViewApplication = lazy(() =>
  import('@sunbit-dev/retailer-customer-view/src/components/app/App').then((module) => ({ default: module.App }))
);

const PreScreenApp = lazy(() => import('./preScreen/components/app/App').then((module) => ({ default: module.App })));

ReactDOM.render(
  <Router>
    <Suspense fallback={<Loader contained />}>
      <Switch>
        <Route
          {...{
            path: PreScreenRoutes.Base,
            render: () => <PreScreenApp />,
          }}
        />
        <Route
          {...{
            path: RetailerCustomerViewRoutes.Base,
            render: () => <RetailerCustomerViewApplication />,
          }}
        />
        <Route
          {...{
            path: '/',
            render: () => <CheckoutApplication />,
          }}
        />
      </Switch>
    </Suspense>
  </Router>,
  document.getElementById('root')
);
